import {Injectable} from '@angular/core';
import {RouterStateSnapshot, ActivatedRouteSnapshot, Router, CanActivate} from '@angular/router';
import {AuthService, ConfigService, StorageService} from "@cosbeni/auth";
import {ActivePromotionConfig} from "../config/active-promotion.config";


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private auth: AuthService, private config: ConfigService, private storage: StorageService) {
        this.config.setTokenPrefix(this.storage.get("database"));
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot) {
        //if (this.auth.isAuthenticated()) {
        //    return true;
        //}
        let token = this.storage.get(ActivePromotionConfig.DATABASE + "_token");
        if (token.split('.').length === 3) {
            // could be a valid JWT or an access token with the same format
            try {
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const exp = JSON.parse(this.b64DecodeUnicode(base64)).exp;
                // jwt with an optional expiration claims
                if (exp) {
                    const isExpired = Math.round(new Date().getTime()) >= exp;
                    if(!isExpired){
                        return true;
                    }
                }
            } catch (e) {
                // pass: Non-JWT token that looks like JWT
                return true;
            }
        }
        console.log("AuthGuard Not Authenticated")
        this.router.navigateByUrl('login');
        return false;
    }

    private b64DecodeUnicode(str) {
        return decodeURIComponent(Array.prototype.map.call(atob(str), c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    }
}
